export default "__VITE_ASSET__FD9A0GVf__"